module.exports = new __parcel__URL__("chrome.9d45e383.svg").toString();